import { Controller } from "@hotwired/stimulus"

// Generic controller for showing/hiding elements based on trigger element value
//
// Usage:
// data-controller="conditional-display"
// data-conditional-display-show-when-value="empty" (default) | "matches" | "not-empty" | "not-matches"
// data-conditional-display-trigger-value-value="specific-value" (required for "matches"/"not-matches")
//
// Targets:
// data-conditional-display-target="trigger" - The element that triggers the toggle
// data-conditional-display-target="field" - The element(s) to show/hide
//
// Example:
// <div data-controller="conditional-display" data-conditional-display-show-when-value="empty">
//   <select data-conditional-display-target="trigger" data-action="change->conditional-display#toggle">
//     <option value="">Select option</option>
//     <option value="existing">Use existing</option>
//   </select>
//   <div data-conditional-display-target="field" class="hidden">
//     <!-- Elements to show when trigger is empty -->
//   </div>
// </div>

export default class extends Controller {
  static targets = ["trigger", "field"]
  static values = {
    triggerValue: String,
    showWhen: { type: String, default: "empty" }
  }

  connect() {
    this.toggle()
  }

  toggle() {
    const triggerValue = this.triggerTarget.value
    const shouldShow = this.shouldShowFields(triggerValue)

    this.fieldTargets.forEach(field => {
      if (shouldShow) {
        field.classList.remove("hidden")
      } else {
        field.classList.add("hidden")
      }
    })
  }

  shouldShowFields(value) {
    switch (this.showWhenValue) {
      case "empty":
        return value === ""
      case "matches":
        return value === this.triggerValueValue
      case "not-empty":
        return value !== ""
      case "not-matches":
        return value !== this.triggerValueValue
      default:
        return value === ""
    }
  }
}
